import { render, staticRenderFns } from "./personPassRule.vue?vue&type=template&id=3e5ab39d&scoped=true"
import script from "./personPassRule.vue?vue&type=script&lang=js"
export * from "./personPassRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ab39d",
  null
  
)

export default component.exports